import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { onChange, getCookie } from '../../../utils';
import CONSTANT from '../../../constant';
import Header from '../../../component/common/UnitLeaveHeader';

import { getDateParts } from '../../../utils';
import { getUnitLeaveRequest } from '../../../actions/UnitLeaveAction';
import Shimmer from '../../../component/common/Shimmer';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            pending: undefined,
            others: undefined,
            date: moment(),
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.allLeaves;

        this.loadList();
    }

    render() {
        const { pending, others, date } = this.state;
        const ud = getCookie(CONSTANT.cookie.userDetail);

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <h1 className="page-title">Pending Request</h1>
                            </div>
                            <div className="col-md-2">
                                {/* <Link to={CONSTANT.component.userLeaveEncashmentList.url} className="btn btn-sm submit-button btn-block">
                                    Leave Encashment
                                </Link> */}
                            </div>
                            <div className="col-md-2">
                                <Link to={CONSTANT.component.unitProxyLeaveRequest.url} className="btn btn-sm submit-button btn-block">
                                    <i className="fa fa-plus-circle mr-2" />
                                    Request Leave
                                </Link>
                            </div>
                            <div className="col-md-2">
                                <input type="month" value={date.format('YYYY-MM')} onChange={this.onChange} className="form-control" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Assigned To</th>
                                                <th scope="col">Requested by</th>
                                                {/* <th scope="col">Address</th> */}
                                                <th scope="col">Leave type</th>
                                                <th scope="col">From Date</th>
                                                <th scope="col">To Date</th>
                                                <th scope="col"># Days</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Modified</th>
                                            </tr>
                                            {
                                                pending === undefined && <tr>
                                                    <td colSpan={9} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                pending !== undefined && pending.length === 0 && <tr>
                                                    <td colSpan={9} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                pending !== undefined && pending.map((item: any, index: number) => {
                                                    const detailPageURL = CONSTANT.component.unitProxyLeaveDetail.url.replace(':code', item.code);
                                                    const dated = getDateParts(item.modifiedOn);
                                                    const fromDate = getDateParts(item.startDate);
                                                    const toDate = getDateParts(item.endDate);
                                                    return (
                                                        <tr key={index} className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.assignedToName}</td>
                                                            <td>{item.createdByName}</td>
                                                            {/* <td>{item.addressTypeName}</td> */}
                                                            <td>{item.leaveTypeName}
                                                                {item.cancelled && <span className="badge badge-danger ml-1">Cancelled</span>}
                                                            </td>
                                                            <td>{`${fromDate.date} ${fromDate.monthName} ${fromDate.year}`}</td>
                                                            <td>{`${toDate.date} ${toDate.monthName} ${toDate.year}`}</td>
                                                            <td>{item.noOfDays}{item.leaveTypeId === CONSTANT.static.leaveType.cml && `(${item.noOfDays * 2} HPL)`}</td>
                                                            <td>
                                                                {
                                                                    item.cancellationRequestedOn === null && item.approved === null && <span>Pending</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn === null && item.approved !== null ? (item.approved ? <span className="text-success">Approved</span> : <span className="text-danger">Rejected</span>) : null
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn === null && <span className="text-info">Cancellation Requested</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn !== null && <span className="text-danger">Leave Cancelled</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn !== null && (item.cancellationStatus ? <span className="text-success">Cancellation Approved</span> : <span className="text-danger">Cancellation Rejected</span>)
                                                                }
                                                            </td>
                                                            <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                        <div className="row mt-3">
                            <div className="col-md-12">
                                <h1 className="page-title">Others</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Assigned To</th>
                                                <th scope="col">Requested by</th>
                                                {/* <th scope="col">Address</th> */}
                                                <th scope="col">Leave type</th>
                                                <th scope="col">From Date</th>
                                                <th scope="col">To Date</th>
                                                <th scope="col"># Days</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Modified</th>
                                            </tr>
                                            {
                                                others === undefined && <tr>
                                                    <td colSpan={9} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                others !== undefined && others.length === 0 && <tr>
                                                    <td colSpan={9} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                others !== undefined && others.map((item: any, index: number) => {
                                                    const detailPageURL = CONSTANT.component.unitProxyLeaveDetail.url.replace(':code', item.code);
                                                    const dated = getDateParts(item.modifiedOn);
                                                    const fromDate = getDateParts(item.startDate);
                                                    const toDate = getDateParts(item.endDate);
                                                    return (
                                                        <tr key={index} className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.assignedToName}</td>
                                                            <td>{item.createdByName}</td>
                                                            {/* <td>{item.addressTypeName}</td> */}
                                                            <td>{item.leaveTypeName}
                                                                {item.cancelled && <span className="badge badge-danger ml-1">Cancelled</span>}
                                                            </td>
                                                            <td>{`${fromDate.date} ${fromDate.monthName} ${fromDate.year}`}</td>
                                                            <td>{`${toDate.date} ${toDate.monthName} ${toDate.year}`}</td>
                                                            <td>{item.noOfDays}</td>
                                                            <td>
                                                                {
                                                                    item.cancellationRequestedOn === null && item.approved === null && <span>Pending</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn === null && item.approved !== null ? (item.approved ? <span className="text-success">Approved</span> : <span className="text-danger">Rejected</span>) : null
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn === null && <span className="text-info">Cancellation Requested</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn !== null && <span className="text-danger">Leave Cancelled</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn !== null && (item.cancellationStatus ? <span className="text-success">Cancellation Approved</span> : <span className="text-danger">Cancellation Rejected</span>)
                                                                }
                                                            </td>
                                                            <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>




                        {/* <div className="row">
                            <div className="col-md-2">
                                <button type="button" onClick={this.previousYear} className="btn btn-link btn-sm next-control btn-block">
                                    <i className="fa fa-angle-double-left mr-1 pe-none" aria-hidden="true"></i>
                                    Year {date.getFullYear() - 1}
                                </button>
                            </div>
                            <div className="col-md-8"></div>
                            <div className="col-md-2">
                                <button type="button" onClick={this.nextYear} className="btn btn-link btn-sm float-right next-control btn-block">
                                    Year {date.getFullYear() + 1}
                                    <i className="fa fa-angle-double-right ml-1 pe-none" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ date: moment(value), pending: undefined, others: undefined }, () => {
            this.loadList();
        });
        // onChange(this, e.target.name, e.target.value);
    }

    loadList = () => {
        const { date } = this.state;
        getUnitLeaveRequest(date.format('YYYY-MM-DD')).then((res: any) => {
            if (res) {
                this.setState({
                    pending: res.result.pending,
                    others: res.result.others
                });
            }
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }
}

export default ComponentName;